import { render } from "./NavigationSide.vue?vue&type=template&id=0650bafb&scoped=true&ts=true&lang=pug"
import script from "./NavigationSide.vue?vue&type=script&lang=ts"
export * from "./NavigationSide.vue?vue&type=script&lang=ts"

import "./NavigationSide.vue?vue&type=style&index=0&id=0650bafb&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0650bafb"]])

export default __exports__